module.exports = __webpack_public_path__ + "_/appcraft-forms/src/components/Flag/flags.png";


/*****************
 ** WEBPACK FOOTER
 ** ../appcraft-forms/src/components/Flag/flags.png
 ** module id = 999
 ** module chunks = 0
 **/